'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' });

var Menu = function Menu(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

Menu = (0, _pure2.default)(Menu);
Menu.muiName = 'SvgIcon';

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/Menu.js
// module id = 2608
// module chunks = 0